import '@fortawesome/fontawesome-free/css/all.css'
import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';


import router from './config/router'
import store from './store/index'

import * as svgicon from 'vue-svgicon';
import $ from 'jquery'

window.$ = $

import Vue2Filters from 'vue2-filters'
import VueGTag from 'vue-gtag'
import "leaflet/dist/leaflet.css";


import {renderImageFromAssets} from './core/assets_utils'

import {BootstrapVue, IconsPlugin} from 'bootstrap-vue'

// Import Bootstrap an BootstrapVue CSS files (order is important)
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'


Vue.config.productionTip = false
Vue.prototype.$renderImageFromAssets = renderImageFromAssets

Vue.use(svgicon, {
    classPrefix: 'AppIcon-',
});

// Optionally install the BootstrapVue icon components plugin
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)

Vue.use(Vue2Filters)

Vue.use(VueGTag, {
    config: {id: process.env.VUE_APP_GOOGLE_TAG_MANAGER_KEY}
})

new Vue({

    router,
    vuetify,
    store,
    render: h => h(App)
}).$mount('#app')
